<template>
  <div>
    <div class="d-flex justify-center">
      <div class="half_w">
        <v-card class="rounded-lg pa-3 temp_notif" height="90vh" flat>
          <div v-if="notification">
            <h3>Notifications</h3>
            <div class="my-3">
              <v-btn
                class="mr-2 text-capitalize"
                rounded
                depressed
                :color="read !== 0 ? 'blue' : ''"
                :dark="read !== 0 ? true : false"
                @click="(read = ''), getNotif()"
                ><b>All</b></v-btn
              >
              <v-btn
                :color="read === 0 ? 'blue' : ''"
                :dark="read === 0 ? true : false"
                class="text-capitalize"
                rounded
                @click="(read = 0), getNotif()"
                depressed
                ><b>Unread</b></v-btn
              >
            </div>
            <div v-if="notification.notification.data.length && !loading">
              <div
                v-for="(item, i) in notification.notification.data"
                :key="i"
                class="mb-1 item_notif"
                @click="toContent(item)"
              >
                <div class="d-flex">
                  <div class="mr-2">
                    <v-icon color="var(--g)" v-if="item.read == 0" small
                      >mdi-circle</v-icon
                    >
                    <v-icon color="white" v-else small>mdi-circle</v-icon>
                  </div>
                  <div>
                    <p class="mb-1" v-html="item.message_html"></p>
                    <p
                      :class="
                        item.read == 0
                          ? 'small_txt color_default ma-0'
                          : 'small_txt thiner  ma-0'
                      "
                    >
                      <b>. {{ $date(item.created_at).fromNow() }}</b>
                    </p>
                  </div>
                </div>
                <!-- <v-divider></v-divider> -->
              </div>
            </div>
            <div
              class="d-flex flex-column align-center"
              v-if="!notification.notification.data.length && !loading"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="lonceng"
                viewBox="0 0 112 112"
              >
                <rect
                  width="18.98"
                  height="18.98"
                  x="34.96"
                  y="82"
                  fill="#1876f2"
                  rx="9.49"
                  transform="rotate(-15 44.445 91.471)"
                />
                <circle cx="43.01" cy="26.27" r="6.85" fill="#64676b" />
                <path
                  fill="#a4a7ab"
                  d="M75.28 43.44a26.72 26.72 0 10-51.62 13.83L30 81l51.62-13.87z"
                />
                <path
                  fill="#a4a7ab"
                  d="M90.78 75.64L26.33 92.9l3.22-13.63 51.62-13.83 9.61 10.2z"
                />
                <rect
                  width="66.91"
                  height="8.88"
                  x="25.35"
                  y="80.75"
                  fill="#a4a7ab"
                  rx="4.44"
                  transform="rotate(-15 58.793 85.207)"
                />
              </svg>
              <h3 class="text-center">You have no notifications</h3>
            </div>
          </div>
          <div v-if="loading">
            <v-skeleton-loader
              v-for="item in 5"
              :key="item"
              class="mb-2"
              type="list-item-avatar"
            ></v-skeleton-loader>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "pageNotif",
  computed: {
    ...mapState({
      notification: (state) => state.notification,
    }),
  },
  components: {},
  data() {
    return {
      loading: false,
      read: "",
    };
  },
  mounted() {
    this.getNotif();
  },
  methods: {
    getNotif() {
      this.loading = true;
      let data = {
        read: this.read,
        limit: 999,
      };
      this.$store
        .dispatch("getNotify", data)
        .then(() => {
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    toContent(item) {
      this.loading = true;
      const currentPath = this.$route.path;
      let body = {
        id: item.id,
      };
      let data = {
        path: `notification/read`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          if (currentPath == item.url) {
            this.$router.go("");
          } else {
            this.$router.push(item.url);
          }
          this.getNotif();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });

          this.loading = false;
        });
    },
  },
};
</script>

<style>
.temp_notif {
  overflow: hidden;
  overflow-y: scroll;
}
/* width */
.temp_notif::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.temp_notif::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 10px;
}

/* Handle */
.temp_notif::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
.temp_notif::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.item_notif {
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
}
.item_notif:hover {
  background: #f2f2f2;
}
.lonceng {
  width: 150px;
  height: 150px;
}
.thiner {
  font-weight: 400;
}
</style>
